import $global from 'stores/global'

export default function makeAgents() { return [
  {
    icon: 'briefcase-01',
    bg: 'var(--success-100)',
    text: 'Meeting-Prep',
    type: 'meeting-prep',
    color: '#269C02'
  },
  {
    icon: 'telescope',
    bg: '#FFE6D5',
    text: 'Market Intelligence',
    type: 'market-intelligence',
    color: '#DB7202'
  },
  {
    icon: 'target-02',
    bg: '#FEF0C7',
    text: 'Account Tracker',
    type: 'account'
  },
  {
    icon: 'feather',
    bg: 'var(--blue-100)',
    text: 'Social Writer',
    type: 'post-writer',
    color: '#0086C9'
  },
  {
    icon: 'database-02',
    bg: '#FBE8FF',
    text: 'Internal Insights',
    type: 'stocks'
  },
  {
    icon: 'user-03',
    bg: 'var(--indigo-100)',
    text: 'Persona Analyst',
    type: 'persona',
    color: '#A343F8'
  },
  {
    icon: 'genrate_icon',
    bg: 'var(--gray-100)',
    text: `${$global.brand_name} Agent`,
    type: 'genrate',
    color: 'var(--text-primary)'
  }
]}